// One request builder for the individual feed and both grouped calls. They had
// drifted: the grouped ones dropped event replay's `source`, `task_days` and the
// Cost Saved and defect restrictions, so a grouped user who picked "Replayed"
// saw the chip and got every event.
export const buildActivityParams = (searchParams, { machine_id, page, per_page }) => {
  const params = {
    machine_id,
    resource_version: 3,
    page,
    per_page,
    order_by: searchParams.order_by,
    search_key: searchParams.search_key,
    type: searchParams.type.map(type => type.toLowerCase()),
    event_type: searchParams.event_type
  };
  if (searchParams.days === 'Custom') {
    params.start_date = searchParams.startDate;
    params.end_date = searchParams.endDate;
  } else if (searchParams.task_days !== undefined) {
    params.task_days = searchParams.task_days;
  } else {
    params.days = searchParams.days;
  }

  const filters = [];
  if (searchParams.state.length) {
    filters.push({ name: 'state', op: 'in', value: searchParams.state });
  }
  if (searchParams.machines.length) {
    filters.push({ name: 'machine_id', op: 'in', value: searchParams.machines });
  }
  if (searchParams.read_status.length) {
    filters.push({ name: 'read_status', op: 'in', value: searchParams.read_status.map(r => r === 'read') });
  }
  if (searchParams.analysis.length) {
    filters.push({ name: 'analysis', op: 'in', value: searchParams.analysis.map(r => r === 'analysed') });
  }
  if (searchParams.suspension_status.length) {
    filters.push({ name: 'suspension', op: 'in', value: searchParams.suspension_status.map(r => r === 'on') });
  }
  if (searchParams.defect.length) {
    filters.push({ name: 'defect', op: 'in', value: searchParams.defect });
  }
  // When navigating from the Total Cost Saved widget, restrict to tasks that have a cost saved value.
  if (searchParams.has_cost_saved && searchParams.type && searchParams.type.includes('task')) {
    filters.push({ name: 'customer_savings', op: 'ne', value: null });
  }
  // When navigating from the defects widgets, restrict to tasks that have a real defect assigned.
  if (searchParams.has_defect && searchParams.type && searchParams.type.includes('task')) {
    filters.push({ name: 'has_defect', op: 'eq', value: true });
  }
  params.filters = filters;

  // Event replay: narrow events by origin (both selected means no narrowing).
  if (searchParams.source && searchParams.source.length === 1) {
    params.source = searchParams.source[0];
  }
  return params;
};

// The sort option's value is an object ({ field, direction }); a persisted or
// hand-built one may still be its JSON text. No sort means the default, by date.
const sortField = (orderBy) => {
  if (!orderBy) return 'timestamp';
  let parsed = orderBy;
  if (typeof orderBy === 'string') {
    try {
      parsed = JSON.parse(orderBy);
    } catch (e) {
      return null;
    }
  }
  return (parsed && parsed.field) || 'timestamp';
};

// The cursor a scroll should continue from, or null to page by number.
//
// A page by number asks every source for page x per_page rows and is refused
// past 10000, while the cursor costs one page however deep it goes. Only the
// date sorts are keyset pageable (the backend refuses a cursor with any other),
// and a new search starts from the top.
export const continuationCursor = (prevState, searchParams, paginate, newContext) => {
  if (!paginate || newContext || !prevState.nextCursor) return null;
  return sortField(searchParams.order_by) === 'timestamp' ? prevState.nextCursor : null;
};
